import React from 'react';

import s from './styles.module.scss';

interface IProps {
  children?: React.ReactNode;
}

const ConsentSectionTitle: React.FC<IProps> = ({ children }) => {
  return <h3 className={s.title}> {children} </h3>;
};

export default ConsentSectionTitle;
